// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ClimateScenarioTypeFromJSON, ClimateScenarioTypeToJSON, ClimateScenarioYearFromJSON, ClimateScenarioYearToJSON, } from './';
export function ClimateScenarioFromJSON(json) {
    return {
        'type': !exists(json, 'type') ? undefined : ClimateScenarioTypeFromJSON(json['type']),
        'year': !exists(json, 'year') ? undefined : ClimateScenarioYearFromJSON(json['year']),
    };
}
export function ClimateScenarioToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'type': ClimateScenarioTypeToJSON(value.type),
        'year': ClimateScenarioYearToJSON(value.year),
    };
}
